// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    api,
    IPaginateApiResponse,
} from 'common/api/resources/Response';
import {
    IGpuModel,
    IGpuModelsListRequest,
    IVGpuProfile,
    IVGpuProfilesListRequest,
} from 'common/api/resources/Gpu/model';
import { QueryBuilder } from 'common/api/resources/Request/QueryBuilder';

export const gpuProfiles = {
    list: (params?: IVGpuProfilesListRequest) => api.get<IPaginateApiResponse<IVGpuProfile[]>>('gpu_profiles', {
        params: new QueryBuilder(params).build(),
    }),
};

export const gpuModels = {
    list: (params?: IGpuModelsListRequest) => api.get<IPaginateApiResponse<IGpuModel[]>>('gpu_models', {
        params: new QueryBuilder(params).build(),
    }),
};
